import React from 'react';
import { Users, Plus, FilterX } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyLeadsStateProps {
  hasActiveFilters: boolean;
  onClearFilters: () => void;
}

export function EmptyLeadsState({ hasActiveFilters, onClearFilters }: EmptyLeadsStateProps) {
  if (hasActiveFilters) {
    return (
      <div className="py-16 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500 shadow-inner">
          <FilterX className="h-7 w-7" aria-hidden="true" />
        </div>
        <h3 className="mb-1.5 text-base font-bold text-slate-800 dark:text-slate-200">No leads match your filters</h3>
        <p className="mb-5 text-xs text-slate-500 dark:text-slate-400 max-w-xs mx-auto font-medium">
          Try a different search term or clear the filters.
        </p>
        <Button variant="outline" className="h-9 px-5 text-sm font-semibold rounded-xl shadow-xs" onClick={onClearFilters}>
          Clear filters
        </Button>
      </div>
    );
  }

  return (
    <div className="py-16 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500 shadow-inner">
        <Users className="h-7 w-7" aria-hidden="true" />
      </div>
      <h3 className="mb-1.5 text-base font-bold text-slate-800 dark:text-slate-200">No leads yet</h3>
      <p className="mb-5 text-xs text-slate-500 dark:text-slate-400 max-w-xs mx-auto font-medium">
        New leads from your connected platforms will show up here.
      </p>
      <Button className="h-9 px-5 text-sm font-semibold rounded-xl shadow-xs gap-1.5">
        <Plus className="h-4 w-4" aria-hidden="true" />
        Add your first lead
      </Button>
    </div>
  );
}
